import './css/index.css'
;(function () {
	const origDispatchEvent = EventTarget.prototype.dispatchEvent

	EventTarget.prototype.dispatchEvent = function (event) {
		if (event.type.startsWith('pe_')) {
			const w = window as any
			if ('swTrackEvent' in w) {
				w.swTrackEvent(event.type)
			}
		}

		return origDispatchEvent.call(this, event)
	}
})()
